import React, { useState } from "react";
import { Typography, Box, IconButton } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import SplitIcon from "@mui/icons-material/VerticalSplit"; // Example icon, replace if needed
import CustomDashboardFilters from "../../components/custom-dashboard-filters"; // Assuming this component is reusable
import "./index.scss";
import { FINANCIAL_YEAR } from "../../core/india-map/utils";
import { TICKET_STATUS } from "../../core/ticket-filters/config";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      labels: {
        color: "black",
      },
    },
    tooltip: {
      callbacks: {
        label: (tooltipItem) => {
          const value = tooltipItem.raw;
          return `${tooltipItem.label}: ${value}`;
        },
      },
      backgroundColor: "#fff",
      titleColor: "#000",
      bodyColor: "#555",
      borderColor: "#ddd",
      borderWidth: 1,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};

const CustomPieChart = ({
  title,
  data = [],
  xDataKey,
  bDataKey,
  filtersConfig = [],
  onApplyFilters,
  isModalOpen,
  loadHmrData,
}) => {
  const [splitView, setSplitView] = useState(false);
  const [splitScreenData, setSplitScreenData] = useState(data);
  const [oemOrgList, setOemOrgList] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [serviceEngineers, setServiceEngineers] = useState([]);
  const [ticketStages, setTicketStages] = useState([]);
  const filters = [
    {
      label: "Financial Year",
      type: "autocomplete",
      options: FINANCIAL_YEAR,
      name: "financialYear",
    },
    {
      label: "Select Oem",
      type: "autocomplete",
      options: oemOrgList || [],
      name: "oemOrg",
    },
    {
      label: "Select Defect",
      type: "autocomplete",
      options: defectCodeList || [],
      name: "defectCode",
    },
    {
      label: "Select Complaint Code",
      type: "autocomplete",
      options: complaintCodes || [],
      name: "complaintCode",
    },
    {
      label: "Select Service Engineer",
      type: "autocomplete",
      options: serviceEngineers || [],
      name: "serviceEngineer",
    },
    {
      label: "Select Ticket Stage",
      type: "autocomplete",
      options: ticketStages || [],
      name: "stage",
    },
    {
      label: "Select Ticket Status",
      type: "autocomplete",
      options: TICKET_STATUS || [],
      name: "status",
    },
  ];
  const filteredData = data.filter((d) => d[bDataKey] > 0);
  const splitScreenFilteredData = splitScreenData.filter(
    (d) => d[bDataKey] > 0
  );
  const updateOrgList = (data) => {
    setOemOrgList(data);
  };

  const handleApplyFilters = (filters, isSplitFilter) => {
    // Make API call here with selectedFilters
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = [filters[key].value];
        } else {
          payload[key] = [filters[key]];
        }
      }
      if (isSplitFilter) {
        loadHmrData(
          {
            ...payload,
          },
          setSplitScreenData
        );
      } else {
        loadHmrData({
          ...payload,
        });
      }
    } else {
      if (isSplitFilter) {
        loadHmrData({}, setSplitScreenData);
      } else {
        loadHmrData({});
      }
    }
  };

  const chartData = {
    labels: filteredData.map((d) => d[xDataKey]),
    datasets: [
      {
        label: "Count",
        data: filteredData.map((d) => d[bDataKey]),
        backgroundColor: [
          "#FF6178",
          "#26A0FC",
          "#24E5A4",
          "#FEBC3B",
          "#8B75D7",
          "#8B008B",
          "#8B0000",
          "#483D8B",
          "rgba(153, 102, 255)",
          "#20B2AA",
        ],
      },
    ],
  };
  const splitScreenChartData = {
    labels: splitScreenFilteredData.map((d) => d[xDataKey]),
    datasets: [
      {
        label: "Count",
        data: splitScreenFilteredData.map((d) => d[bDataKey]),
        backgroundColor: [
          "#FF6178",
          "#26A0FC",
          "#24E5A4",
          "#FEBC3B",
          "#8B75D7",
          "#8B008B",
          "#8B0000",
          "#483D8B",
          "rgba(153, 102, 255)",
          "#20B2AA",
        ],
      },
    ],
  };
  return (
    <div className="custom-pie-chart-container">
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6">{title}</Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* <div onClick={(event) => event.stopPropagation()}>
            {!splitView && (
              <CustomDashboardFilters
                filters={filters}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
              />
            )}
          </div> */}
          {/* {isModalOpen && !splitView && (
            <IconButton onClick={() => setSplitView(true)} title="Split View">
              <SplitIcon />
            </IconButton>
          )} */}
        </Box>
      </Box>

      <div
        className={`pi-chart-doughnut ${splitView ? "split-view" : ""}`}
        style={{ display: splitView ? "flex" : "block", gap: "16px" }}
      >
        <div style={{ width: splitView && "50%" }}>
          {splitView && (
            <div className="hmr-filter-con">
              <CustomDashboardFilters
                filters={filters}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
              />
            </div>
          )}
          <div>
            {filteredData.length > 0 ? (
              <Doughnut data={chartData} options={options} height={400} />
            ) : (
              <Typography>No data to display</Typography>
            )}
          </div>
        </div>
        {splitView && (
          <div style={{ width: "50%" }}>
            <div className="hmr-filter-con">
              <CustomDashboardFilters
                filters={filters}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
                isSplitFilter={true}
              />
            </div>
            <div className="chart-section">
              {splitScreenFilteredData.length > 0 ? (
                <Doughnut
                  data={splitScreenChartData}
                  options={options}
                  height={400}
                />
              ) : (
                <Typography>No data to display</Typography>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPieChart;
